import { Component, Input, OnInit, Output, EventEmitter, AfterViewInit, OnChanges, SimpleChange, SimpleChanges, ViewEncapsulation, ViewChild, AfterViewChecked } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig, SelectedFiles } from '../dynamic-form/dynamicForm.interface';
import { AsyncSubject, Observable, Subject, take, takeUntil } from 'rxjs';
// this litle shit sanitize HTML, idk if this actualy work
import { DomSanitizer } from '@angular/platform-browser';
import { slideDownUp } from '../global-app-animations';



@Component({
    selector: 'app-custom-input',
    templateUrl: './custom-input.component.html',
    styleUrls: ['./custom-input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [slideDownUp],
    standalone: false
})

export class CustomInputComponent implements AfterViewInit, OnInit, OnChanges {
  @ViewChild('inputEl') inputEl: HTMLInputElement | undefined;
  @Input() field!: FieldConfig;
  @Input() group!: FormGroup;

  @Output() changeValue: EventEmitter<any> = new EventEmitter<any>();
  @Output() keyUp: EventEmitter<any> = new EventEmitter<any>();

  keyUpSub$ = new Subject<string>();

  inputMinValue: string | undefined;
  inputMaxValue: string | undefined;

  value: string = "";
  valueSvg: any;
  fileError: boolean = false;
  fileErrorType: boolean = false;

  passwIcon: string = 'e-icons cursor-pointer spass e-eye';
  acceptedImages: string = 'image/png,image/jpeg';
  uploadText: string = 'Carica un\'immagine';


  constructor(
    private sanitizer: DomSanitizer
  ) {

  }

  // #region TEST

  // #endregion
  ngOnInit() {
    // secure image
    if (this.field.noBase64 == true) {
      if (this.field.value != undefined) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(this.field.value, "image/svg+xml");
        console.error(doc);
        this.valueSvg = 'a';
        // Append the SVG fragment to the div
        setTimeout(() => {
          //document.getElementById(this.field.name + 'svgM')!.appendChild(doc.documentElement);
          document.getElementById(this.field.name + 'svgM')?.replaceChildren(doc.documentElement);
        }, 200);
      }
    } else {
      this.value = this.field.value;
    }



    if (this.field.fileUploadType != undefined) {
      this.acceptedImages = this.field.fileUploadType;
    }
    if (this.field.label != undefined) {
      this.uploadText = this.field.label;
    }

    // set min and max value
    if (this.field != undefined && this.field.options != undefined) {
      if ('inputMinValue' in this.field.options) {
        this.inputMinValue = this.field.options.inputMinValue;
      }

      if ('inputMaxValue' in this.field.options) {
        this.inputMaxValue = this.field.options.inputMaxValue;
      }


    }
  }

  ngAfterViewInit(): void {
    // set focus on element
    /*if(this.field != undefined && this.field.autoFocus != undefined && this.field.autoFocus != false) {
      document.getElementById(this.field.name)!.focus();
    }*/
    // set the value
    //this.inputEl!.value = this.group && (this.field.value as CustomInputComponent).changeValue ? (this.field.value as CustomInputComponent).changeValue!: this.field.value;
  }

  ngOnChanges(changes: { autoFocus: SimpleChange, field: SimpleChange }): void {

    console.warn(changes);
    console.error("CHANGES INPUT")
    if (changes.autoFocus) {
      console.warn("autofocus");
    }
  }

  onKeyUp(event: any) {
    let data: Object = {
      value: event.srcElement.value,
      name: this.field.name,
    }
    this.keyUp.emit(data);
  }

  onFocus(event: any) {
    const elem = event.target || event.srcElement;
    elem.select();
  }

  onChangeValue(event: any) {
    this.changeValue.emit(event);
  }


  showPassword() {
    const pwdI = document.getElementById('pwdInput');
    if (this.passwIcon.includes('-slash')) {
      this.passwIcon = this.passwIcon.replace('-slash', '');
      pwdI?.setAttribute('type', 'password');
      console.log('removed slash');
    } else {
      this.passwIcon += '-slash';
      pwdI?.setAttribute('type', 'text');
      console.log('added slash');
    }
  }

  beforeTooltipOpen(e: any) {
    if (this.field != undefined || this.field != null) {
      if (this.field.tooltip == null || this.field.tooltip == undefined || this.field.tooltip == '') {
        e.cancel = true;
      }
    }
  }

  //methods for number input

  increase(){
    this.group.controls[this.field.name].setValue(+this.group.controls[this.field.name].value + 1);
  }

  decrease(){
    if(this.field.value > 0){
      
      this.group.controls[this.field.name].setValue(+this.group.controls[this.field.name].value - 1);
    }
  }

  //BASE64 file transformation

  loadLogoToBase64(event: any) {
    console.warn(event);
    console.warn("THIS IS UPLOADED FILE");
    console.warn(event.srcElement.files[0]);
    
    this.fileError = false;
    this.fileErrorType = false;
    
    let limit = 10 * 1024 * 1024;
    let file: File = event.srcElement.files[0];

    console.warn(file.size);
    console.warn(limit);

    console.warn(file.type);

    console.warn(this.acceptedImages);

    let fileTypes = this.acceptedImages.split(',');

    if (!fileTypes.includes(file.type)) {
      this.fileErrorType = true;
      return;
    }

    if (file.size > limit) {
      this.fileError = true;
      return;
    }

    if (this.field.noBase64 == true) {
      this.svgStuff(event);
    } else {
      console.warn("file is base64 stuff");
      this.base64Stuff(event);
    }


  }

  svgStuff(event: any) {
    console.warn("file no base64");
    const file = event.target.files[0];

    const reader = new FileReader();
    reader.onloadend = () => {
      const data = reader.result as string;
      //console.warn("THIS IS SVG AS STRING");
      //console.warn(data);

      let dataCopy = data;

      //dataCopy = dataCopy.replace('<svg', `<svg id="${this.field.name}svg" `);     

      //dataCopy = this.modifySvgSize(dataCopy, 300, 300);

      // edit svg size
      //  console.warn("BYPASS security errore for HTML sanification");
      //this.valueSvg = this.sanitizer.bypassSecurityTrustHtml(dataCopy);
      var parser = new DOMParser();
      var doc = parser.parseFromString(data, "image/svg+xml");
      console.error(doc);
      this.valueSvg = 'a';
      // Append the SVG fragment to the div
      setTimeout(() => {

        //document.getElementById(this.field.name + 'svgM')!.appendChild(doc.documentElement);
        document.getElementById(this.field.name + 'svgM')?.replaceChildren(doc.documentElement)
      }, 200);


      /*setTimeout(() => {
        document.getElementById(`${this.field.name}svg`)?.removeAttribute("width");
        document.getElementById(`${this.field.name}svg`)?.removeAttribute("height");
        document.getElementById(`${this.field.name}svg`)?.setAttribute("style","width:300px");
        document.getElementById(`${this.field.name}svg`)?.setAttribute("style","height:300px");                    
      }, 10);*/

      let dataEmit: Object = {
        name: this.field.name,
        value: dataCopy,
      };

      this.group.controls[this.field.name].setValue(dataCopy);
      this.group.controls[this.field.name].markAsDirty();
      this.group.controls[this.field.name].updateValueAndValidity();

      this.keyUp.emit(dataEmit);
    }

    if (file) {
      reader.readAsText(file);
    }
  }

  // Function to modify the size of the SVG string
  modifySvgSize(svgString: string, newSize: number, newHeight: number): string {
    // Modify the style attribute with the new size and height
    let modifiedSvgString = svgString.replace(/height=".*?"/, '');
    modifiedSvgString = modifiedSvgString.replace(/width=".*?"/, '');
    modifiedSvgString = modifiedSvgString.replace(/id=".*?"/, '');
    modifiedSvgString = modifiedSvgString.replace(/style=".*?"/, `style="width:${newSize}px;height:${newHeight}px"`);
    return modifiedSvgString;
  }

  base64Stuff(event: any) {

    this.toFilesBase64(event.srcElement.files).pipe(take(1)).subscribe({
      next: (resp: SelectedFiles) => {

        this.value = resp.base64 ?? '';

        let data: Object = {
          value: resp.base64,
          name: this.field.name,
        }

        this.group.controls[this.field.name].setValue(resp.base64 ?? '');
        this.group.controls[this.field.name].markAsDirty();
        this.group.controls[this.field.name].updateValueAndValidity();

        this.keyUp.emit(data);

        //console.log(data)

      }
    });

  }


  //Convert file to base64
  public toFilesBase64(files: File[]): Observable<SelectedFiles> {
    const result = new AsyncSubject<SelectedFiles>();
    if (files?.length) {
      Object.keys(files)?.forEach(async (file, i) => {
        const reader = new FileReader();
        reader.readAsDataURL(files[i]);
        reader.onload = (e) => {

          var selectedFiles = { name: files[i]?.name, file: files[i], base64: reader?.result as string };
          result.next(selectedFiles);
          if (files?.length === (i + 1)) {
            result.complete();
          }
        };
      });
      return result;
    } else {
      result.complete();
      return result;
    }
  }

}
